import { createFileRoute } from '@tanstack/react-router'
import { CustomersPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customers/')({
  component: CustomersPage,
  beforeLoad: requireRole(['admin']),
})
